import { render, staticRenderFns } from "./yati.vue?vue&type=template&id=3165c3d6&scoped=true&"
import script from "./yati.vue?vue&type=script&lang=js&"
export * from "./yati.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3165c3d6",
  null
  
)

export default component.exports